<script lang="ts" setup>
import { computed, type PropType } from 'vue';

import getPrecision from '@exchange/helpers/get-precision';
import type { MarketModel } from '@exchange/libs/market/service/src';
import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

const props = defineProps({
  listType: { type: String as PropType<MyOrdersListType>, required: true },
  market: { type: Object as PropType<MarketModel> },
  mobile: { type: Boolean, default: false },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
});

const total = computed(() =>
  OrderWithTradesModel.getTotalToDisplay(props.order.type, props.order.amount, props.order.total, props.order.price, props.order.trades, props.listType !== MyOrdersListType.open),
);

const precision = computed(() => getPrecision(total.value, props.market?.totalPrecision, true));
</script>

<template>
  <div class="order-total">
    <span
      v-if="mobile"
      class="order-total__title"
      >{{ $t('modules.myOrders.header.total') }}:</span
    >
    <ot-number-display
      class="order-total__value"
      :number="total"
      :precision="precision"
      :suffix="order.quoteCurrencyCode"
    />
  </div>
</template>

<style lang="scss">
.order-total {
  &__title {
    color: var(--titles-color);
  }

  &__value {
    color: var(--number-total-color);
  }
}
</style>
